import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../lib/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

const Works = () => {
  const [portfolios, setPortfolios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPortfolios = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const portfoliosRef = collection(db, 'portfolios');
        const q = query(portfoliosRef, where('is_published', '==', true)); // Fetch published only
        const querySnapshot = await getDocs(q);
        let portfolioList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Client-side sort by created_at in descending order
        portfolioList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        setPortfolios(portfolioList);
      } catch (err) {
        console.error("Error fetching portfolios for Works component: ", err);
        setError("포트폴리오를 불러오는 데 실패했습니다.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchPortfolios();
  }, []);

  if (isLoading) {
    return (
      <section className="works_home_wrap">
        <div className="works_home_heading">
          <h2 className="works_home_text u-text-display u-sr-only">Works</h2>
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="works_home_wrap">
        <div className="works_home_heading">
          <h2 className="works_home_text u-text-display u-sr-only">Works</h2>
          <div className="text-center p-10 text-red-500">{error}</div>
        </div>
      </section>
    );
  }

  if (portfolios.length === 0) {
    return (
      <section className="works_home_wrap">
        <div className="works_home_heading">
          <h2 className="works_home_text u-text-display u-sr-only">Works</h2>
          <div className="text-center p-10">등록된 포트폴리오가 없습니다.</div>
        </div>
      </section>
    );
  }

  return (
    <section className="works_home_wrap">
      <div className="works_home_heading">
        <h2 className="works_home_text u-text-display u-sr-only">Works</h2>
        <div className="">
          <div aria-hidden={true} className="u-text-display">Works</div>
          <div aria-hidden={true} className="works_home_dynamic u-text-display"></div>
        </div>
      </div>
      <div className="works_collection_wrap w-dyn-list">
        <div role="list" className="works_collection_list u-grid-custom w-dyn-items">
          {portfolios.map((portfolio, index) => (
            <div role="listitem" className="works_collection_item w-dyn-item" key={portfolio.id}>
              <Link to={`/project/${portfolio.id}`} className="works_item_wrap w-inline-block">
                <div data-image-reveal="" className="works_image_cover">
                  <div data-image-cover="" className="g_image_cover"></div>
                  {portfolio.thumbnail_url ? (
                    <img
                      src={portfolio.thumbnail_url}
                      loading="lazy"
                      data-orientation={portfolio.orientation || 'portrait'} // Assuming orientation might be in data
                      data-image=""
                      alt={portfolio.title}
                      className="works_item_image"
                      onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop&q=80'; }}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-200">
                      <div className="text-center">
                        <div className="text-gray-400 text-4xl mb-2">🏠</div>
                        <p className="text-gray-500 text-sm">이미지 없음</p>
                      </div>
                    </div>
                  )}
                </div>
                <div className="works_content_wrap u-text-small">
                  <div className="works_content_title">
                    <div className="works_content_index">
                      <div className="works_content_dynamic">{(index + 1).toString().padStart(2, '0')}<span className="works_content_value"></span></div>
                    </div>
                    <div className="works_content_project">{portfolio.title}</div>
                  </div>
                  <div className="works_content_aside">
                    <div className="works_content_year">{new Date(portfolio.created_at).getFullYear()}</div>
                    <div className="works_content_year w-condition-invisible">{portfolio.location}</div>
                    <div className="works_content_cta">자세히보기</div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <div className="works_home_cta">
        <a data-link-hover="" data-wf--btn-main--variant="base" href="/works" className="btn_default_wrap w-inline-block">
          <div className="btn_default_contain">
            <div data-link="" className="btn_default_text">전체보기</div>
          </div>
          <div className="g_circle is-light"></div>
        </a>
      </div>
    </section>
  );
};

export default Works;